'use client';

import { EntityProcedureScheduleCard } from '@/app/(main)/(pages)/_components/entities/entity-procedure/entity-procedure-schedule-card.component';
import { EntityProcedureProfessionalCard } from '@/app/(main)/(pages)/_components/entities/entity-procedure/_components/entity-procedure-professional-card.component';
import { EntityProceduresSection } from '@/app/(main)/(pages)/_components/entities/entity-procedure/entity-procedures-section.component';
import { UsePartnerProceduresReturn } from '@/app/(main)/(pages)/(institucional)/(index)/parceiros/_hooks/use-partner-procedures.hook';

interface PartnerSchedulesSectionProps {
  procedures: UsePartnerProceduresReturn;
  className?: string;
  scrollTargetId?: string;
}

export function PartnerSchedulesSection({
  procedures,
  className,
  scrollTargetId,
}: PartnerSchedulesSectionProps) {
  return (
    <EntityProceduresSection
      procedures={procedures}
      title="Atendimentos"
      className={className}
      scrollTargetId={scrollTargetId}
      renderProcedure={(procedure, index) => (
        <EntityProcedureScheduleCard
          key={procedure.id}
          accordionKey={procedure.id}
          title={procedure.name}
          defaultOpen={index === 0}
        >
          {procedure.professionals.map((professional) => (
            <EntityProcedureProfessionalCard key={professional.id} professional={professional} />
          ))}
        </EntityProcedureScheduleCard>
      )}
    />
  );
}
